<script setup>
const globalStore = useGlobal()
</script>

<template>
    <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
        <!-- Navbar -->
        <Navbar />

        <!-- Main Content -->
        <div class="flex-1 mt-16">
            <div class="mx-auto max-w-7xl py-7 px-3 md:py-12 md:px-5">
                <slot></slot>
            </div>

            <!-- Footer -->
            <Footer></Footer>
        </div>

        <!-- Message Modal -->
        <MessageModal v-if="globalStore.messageModal.visible"
            :type="globalStore.messageModal.type"
            :title="globalStore.messageModal.title"
            :message="globalStore.messageModal.message"
            @close="globalStore.messageModal.visible = false" />

        <!-- Busy Indicator -->
        <Busy :show="globalStore.busy" />
    </div>
</template>